import { createRouter } from '@ionic/vue-router';
import { RouteRecordRaw, createWebHashHistory } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import LoginPage from '../views/LoginPage.vue';
import ExplotacionListPage from '../views/ExplotacionListPage.vue';
import FirstAccessPage from '../views/FirstAccessPage.vue';
import { useUser } from '@/composables/useUser';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
  },
  {
    name: 'Explotaciones',
    path: '/explotaciones',
    component: ExplotacionListPage,
  },
  {
    name: 'FirstAccess',
    path: '/first-access',
    component: FirstAccessPage,
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: 'usuario',
        name: 'Usuario',
        component: () => import('@/views/UsuarioPage.vue')
      },
      {
        path: 'notificaciones',
        name: 'Notificaciones',
        component: () => import('@/components/notificaciones/ListNotificacionComponent.vue')
      },
      {
        path: 'explotacion',
        name: 'Explotacion',
        component: () => import('@/views/ExplotacionItemPage.vue')
      },
      {
        path: 'actas',
        name:'Actas',
        component: () => import('@/views/ActasListPage.vue')
      },
      {
        path: 'lotes',
        name:'Lotes',
        component: () => import('@/views/LotesPage.vue')
      },
      {
        path: 'informes/list',
        name:'Informes',
        component: () => import('@/views/InformesPage.vue'),        
      },
      {
        path: 'informes/detail',
        name:'Detalle del Informe',
        component: () => import('@/components/informes/InformeItemComponent.vue')
      },
      {
        path: 'informes/new-informe-re',
        name:'Nuevo Informe Re',
        component: () => import('@/components/informes/InformeReComponent.vue')
      },
      {
        path: 'informes/new-informe-rea',
        name:'Nuevo Informe Rea',
        component: () => import('@/components/informes/InformeReaComponent.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach(async (to,from,next) => {

  const { checkIsValidSession, get }  = useUser();
  const tokenUser = await checkIsValidSession();
  
  if (to.name === 'Login') {
    return next();
  }
  
  if (tokenUser==null) {
    return next({ name: 'Login' });
  };
  
  const user = await get();
  if (user?.first_access && to.name !== 'FirstAccess') {
    return next({ name: 'FirstAccess' });
  }
  
  return next();  

});

export default router
